(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text"] && !Shopify.designMode) return;
  try {
    
  const el = document.getElementById('{{ section.id }}-expand');
  if (el) {
    el.addEventListener('click', () => {
      el.previousElementSibling.classList.toggle('hidden');
      el.textContent = el.textContent === 'ausklappen/einklappen' ? 'ausklappen' : 'ausklappen/einklappen';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text"] && !Shopify.designMode) return;
  try {
    
  const el = document.getElementById('{{ section.id }}-expand');
  if (el) {
    el.addEventListener('click', () => {
      el.previousElementSibling.classList.toggle('hidden');
      el.textContent = el.textContent === 'ausklappen/einklappen' ? 'ausklappen' : 'ausklappen/einklappen';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  const el = document.getElementById('{{ section.id }}-expand');
  if (el) {
    el.addEventListener('click', () => {
      el.previousElementSibling.classList.toggle('hidden');
      el.textContent = el.textContent === 'ausklappen/einklappen' ? 'ausklappen' : 'ausklappen/einklappen';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video_text"] && !Shopify.designMode) return;
  try {
    
  const el = document.getElementById('{{ section.id }}-expand');
  if (el) {
    el.addEventListener('click', () => {
      el.previousElementSibling.classList.toggle('hidden');
      el.textContent = el.textContent === 'ausklappen/einklappen' ? 'ausklappen' : 'ausklappen/einklappen';
    });
  }

  } catch(e) { console.error(e); }
})();
})();
